import type { RouteRecordRaw } from 'vue-router';

export const dentalDashboardRoutes: RouteRecordRaw[] = [
  {
    path: 'dental/dashboard',
    name: 'dental-dashboard',
    component: () => import('./pages/DentalDashboardPage.vue'),
    meta: { title: 'Dental overview', requiresAuth: true, permission: 'view_patients' },
  },
];
